import * as React from 'react';
import { Moment } from 'moment';
import styles from './Columns.module.scss';

const DateTimeColumn: React.FC<IProps> = props => (
  <div>
      {props.date.clone().local().format('DD.MM.YYYY [в] HH:mm')}
      <div className={styles.subRow}>
          {props.date.clone().tz('Europe/Moscow').format('HH:mm [МСК]')}
      </div>
  </div>
);

interface IProps {
    date: Moment;
}

export default DateTimeColumn;
